import React, { useEffect, useState, Component } from "react";



class InstagramIcon extends Component {

  constructor(props) {
    super(props);
    this.state = {
     
    }
  
  }


  componentDidMount() {
    let THIS = this;
   
  }

  componentDidUpdate() {


  }


  render() {

    return (

      <React.Fragment>
       
        <img src="/assets/icons/instagram.png" alt="instagram" title="instagram" />
       
      </React.Fragment>
    );
  }
}


export default InstagramIcon;


// WEBPACK FOOTER //
// ./src/components/bewise/instagramicon.jsx